var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanceled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7027_214161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.5C2.46641 0.5 0 2.96641 0 6C0 9.03359 2.46641 11.5 5.5 11.5C8.53359 11.5 11 9.03359 11 6C11 2.96641 8.53359 0.5 5.5 0.5Z",
    fill: "#FF29EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36337 4.85028C7.53684 4.68859 7.54642 4.41688 7.38471 4.24339C7.22304 4.06991 6.95131 4.06035 6.77784 4.22204L5.52137 5.39311L4.35028 4.13663C4.18859 3.96315 3.91688 3.95359 3.74339 4.11528C3.56991 4.27697 3.56035 4.54868 3.72204 4.72217L4.89311 5.97864L3.63663 7.14975C3.46315 7.31141 3.45359 7.58314 3.61528 7.75662C3.77697 7.93009 4.04868 7.93967 4.22217 7.77796L5.47864 6.6069L6.64975 7.86337C6.81141 8.03684 7.08314 8.04642 7.25662 7.88471C7.43009 7.72304 7.43967 7.45131 7.27796 7.27784L6.1069 6.02137L7.36337 4.85028Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7027_214161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanceled);
export default ForwardRef;